import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=2ff360f3&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=2ff360f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff360f3",
  null
  
)

export default component.exports